// @ts-nocheck
import { Box, MenuItem, MenuList, Typography } from '@mui/material';
import GenericToolTip from 'components/__v2__/GenericToolTip';
import React from 'react';

function ResourceInfo({ title, subTitle }) {
  return (
    <MenuList dense sx={{ padding: 0 }}>
      <MenuItem sx={{ padding: '2px 16px' }}>
        <Box display="flex" sx={{ gap: 2 }} my={1}>
          <Typography variant="subtitle2">{title}:</Typography>
          <Typography variant="body2" sx={{ textWrap: 'balance' }}>
            <GenericToolTip title={subTitle} char={15} />
          </Typography>
        </Box>
      </MenuItem>
    </MenuList>
  );
}

export default ResourceInfo;
